import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { PainAgitation } from './components/PainAgitation';
import { SystemReveal } from './components/SystemReveal';
import { Results } from './components/Results';
import { Offer } from './components/Offer';
const PIXEL_ID = '1598735997991200';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
function initFacebookPixel() {
  if (window.fbq) return;
  const n: any = window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
}
export function App() {
  useEffect(() => {
    initFacebookPixel();
  }, []);
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#E8856C] selection:text-white" data-id="element-0">
      {/* Font Imports */}
      <style data-id="element-1">{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400;1,600&display=swap');
        
        :root {
          --font-sans: 'Inter', sans-serif;
          --font-serif: 'Playfair Display', serif;
        }
        
        body {
          font-family: var(--font-sans);
        }
        
        h1, h2, h3, h4, h5, h6 {
          font-family: var(--font-serif);
        }
      `}</style>

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PainAgitation data-id="element-4" />
        <SystemReveal data-id="element-5" />
        <Results data-id="element-6" />
        <Offer data-id="element-7" />
      </main>

      <footer className="bg-[#3D2B1F] text-[#FFF8F0]/40 py-8 text-center text-sm border-t border-[#FFF8F0]/10" data-id="element-8">
        <p data-id="element-9">
          © {new Date().getFullYear()} Mamitas Latinas. Todos los derechos
          reservados.
        </p>
        <p className="mt-2" data-id="element-10">Hecho con amor y paciencia.</p>
      </footer>
    </div>;
}